import { render, staticRenderFns } from "./StudentsGenderChart.vue?vue&type=template&id=3efb023c&scoped=true&"
import script from "./StudentsGenderChart.vue?vue&type=script&lang=js&"
export * from "./StudentsGenderChart.vue?vue&type=script&lang=js&"
import style0 from "./StudentsGenderChart.vue?vue&type=style&index=0&id=3efb023c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efb023c",
  null
  
)

export default component.exports